import { SVGProps } from 'react';

export type SVGRProps = {
  title?: string;
  titleId?: string;
};

const SvgInterfacecheck = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    aria-labelledby={titleId}
    fill="none"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      clipRule="evenodd"
      d="m18.747 7-8.632 8.519-5.061-5L4 11.57l6.113 6.039 9.685-9.565L18.747 7Z"
      fill={props.color}
      fillRule="evenodd"
    />
  </svg>
);

export default SvgInterfacecheck;
